/* eslint-disable import/no-anonymous-default-export */
import * as types from './types';

const initialState = {
  savedJobs: [],
  selectedSavedJob: undefined,
  numOfSavedJobs: undefined,
  numOfApplyingJobs: undefined,
  numOfAppliedJobs: undefined,
  isSavedJobsLoading: false,
  savedJobsObj: [],
  searchParams: {
    query: "",
    jobSearchQueries: [],
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.SET_SAVED_JOBS:
    case types.SET_STATS:    
      return {
        ...state,
        ...payload,
      };
    case types.SET_SEARCH_PARAMS:
      
      const newObj = {
        ...state,
        ...payload,
      }
      return newObj

    default:
      return state;
  }
}
